module.exports = __webpack_public_path__ + "img/x.1adcb13e.svg";